import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Plane } from 'assets/images/plane-flying.svg';

type PlaneIconProps = {
  $direction?: string;
};

export const FlightWrapper = styled.div`
  display: flex;
  margin: 8px 0 0;

  &:last-child:not(:first-child) {
    margin-left: auto;
  }
`;

export const PlaneIcon = styled(Plane)<PlaneIconProps>`
  height: 16px;
  margin-top: 4px;
  margin-right: 10px;
  transform: scaleX(${({ $direction }) => ($direction === 'to' ? '1' : '-1')});
`;

export const ShimmerIcon = styled.div`
  width: 16px;
  height: 16px;
  margin-top: 4px;
  margin-right: 10px;
`;

export const Airports = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Arrow = styled.span`
  display: inline;

  &::before {
    content: ' -> ';
    letter-spacing: -0.2em;
    margin-right: 0.4em;
  }
`;
